module.exports = require("./fr-PM.d.ts");